import { RuleIds } from "../../models/KnxRule";

// import mdtButton_mapSignalToTag from "./Rules/MDT/mapSignalToTag.js?raw";
// import mertenButton_mapSignalToTag from "./Rules/Merten/mapSignalToTag.js?raw";
// import jungButton_mapSignalToTag from "./Rules/Jung/mapSignalToTag.js?raw";

import giraDecentralActor_mapSignalToTag from "./Rules/Gira/mapSignalToTag.js?raw";
import genericDecentralActor_mapSignalToTag from "./Rules/Generic/mapSignalToTag.js?raw";

const Gira_Rules = {
  [RuleIds.mapSignalToTag]: giraDecentralActor_mapSignalToTag,
};

const Fallback_Rules = {
  [RuleIds.mapSignalToTag]: genericDecentralActor_mapSignalToTag,
};

const ManufacturerDecentalActorRules = {
  // ["M-0083"]: MDT_Rules,
  // ["M-0004"]: Jung_Rules,
  // ["M-000C"]: Merten_Rules,
  // ["M-0064"]: Merten_Rules,

  ["M-0008"]: Gira_Rules, // no itx
  ["M-xxxx"]: Fallback_Rules,
};

export default ManufacturerDecentalActorRules;
